import { render, staticRenderFns } from "./projectAnalysis.vue?vue&type=template&id=4d627e66&scoped=true"
import script from "./projectAnalysis.vue?vue&type=script&lang=js"
export * from "./projectAnalysis.vue?vue&type=script&lang=js"
import style0 from "./projectAnalysis.vue?vue&type=style&index=0&id=4d627e66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d627e66",
  null
  
)

export default component.exports